import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = BACKEND_URL;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("rit_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;

// Public
export const fetchTours = (category) =>
  api.get("/tours", { params: category ? { category } : {} }).then((r) => r.data);
export const fetchTour = (id) => api.get(`/tours/${id}`).then((r) => r.data);
export const submitBooking = (payload) => api.post("/bookings", payload).then((r) => r.data);
export const submitInquiry = (payload) => api.post("/inquiries", payload).then((r) => r.data);
export const submitNewsletter = (email, language = "en") =>
  api.post("/newsletter", { email, language }).then((r) => r.data);
export const translateBatch = (texts, target, source = "en") =>
  api.post("/translate", { texts, target, source }).then((r) => r.data);

export const fetchBlogPosts = () => api.get("/blog").then((r) => r.data);
export const fetchPages = () => api.get("/pages").then((r) => r.data);
export const fetchPage = (slug) => api.get(`/pages/${slug}`).then((r) => r.data);
export const fetchBlogPost = (slug) => api.get(`/blog/${slug}`).then((r) => r.data);

// Admin
export const loginAdmin = (email, password) =>
  api.post("/auth/login", { email, password }).then((r) => r.data);
export const adminMe = () => api.get("/auth/me").then((r) => r.data);

export const adminListTours = () => api.get("/tours", { params: { active: false } }).then((r) => r.data);
export const adminCreateTour = (payload) => api.post("/tours", payload).then((r) => r.data);
export const adminUpdateTour = (id, payload) => api.put(`/tours/${id}`, payload).then((r) => r.data);
export const adminSetTourDateStatus = (id, date, closed) => api.put(`/tours/${id}/date-status`, { date, closed }).then((r) => r.data);
export const adminDeleteTour = (id) => api.delete(`/tours/${id}`).then((r) => r.data);
export const adminReorderTours = (orders) => api.post("/tours/reorder", { orders }).then((r) => r.data);

export const adminListBookings = () => api.get("/bookings").then((r) => r.data);
export const adminUpdateBooking = (id, payload) => api.put(`/bookings/${id}`, payload).then((r) => r.data);
export const adminDeleteBooking = (id) => api.delete(`/bookings/${id}`).then((r) => r.data);

export const adminListInquiries = () => api.get("/inquiries").then((r) => r.data);
export const adminDeleteInquiry = (id) => api.delete(`/inquiries/${id}`).then((r) => r.data);

export const adminListBlog = () => api.get("/blog", { params: { published: false } }).then((r) => r.data);
export const adminListPages = () => api.get("/pages", { params: { published: false } }).then((r) => r.data);
export const adminCreatePage = (payload) => api.post("/pages", payload).then((r) => r.data);
export const adminUpdatePage = (slug, payload) => api.put(`/pages/${slug}`, payload).then((r) => r.data);
export const adminDeletePage = (slug) => api.delete(`/pages/${slug}`).then((r) => r.data);
export const adminCreateBlog = (payload) => api.post("/blog", payload).then((r) => r.data);
export const adminUpdateBlog = (slug, payload) => api.put(`/blog/${slug}`, payload).then((r) => r.data);
export const adminDeleteBlog = (slug) => api.delete(`/blog/${slug}`).then((r) => r.data);

export const fetchSite = () => api.get("/site").then((r) => r.data);
export const adminUpdateSite = (payload) => api.put("/site", payload).then((r) => r.data);
export const adminSiteHistory = () => api.get("/site/history").then((r) => r.data);
export const adminSiteUndo = () => api.post("/site/undo").then((r) => r.data);

export const adminUploadImage = (file) => {
  const form = new FormData();
  form.append("file", file);
  return api
    .post("/uploads/image", form, { headers: { "Content-Type": "multipart/form-data" } })
    .then((r) => r.data);
};
export const adminListMedia = () => api.get("/media").then((r) => r.data);
export const adminDeleteMedia = (name) => api.delete(`/media/${name}`).then((r) => r.data);

export const adminGetEmailSettings = () => api.get("/email-settings").then((r) => r.data);
export const adminUpdateEmailSettings = (payload) => api.put("/email-settings", payload).then((r) => r.data);
export const adminSendTestEmail = (to) => api.post("/email-settings/test", { to }).then((r) => r.data);
export const adminListSubscribers = () => api.get("/newsletter/subscribers").then((r) => r.data);

export const adminListEmailLogs = (statusFilter) =>
  api.get("/email-logs", { params: statusFilter ? { status_f: statusFilter } : {} }).then((r) => r.data);
export const adminGetEmailLog = (logId) => api.get(`/email-logs/${logId}`).then((r) => r.data);
export const adminResendEmail = (logId) => api.post(`/email-logs/${logId}/resend`).then((r) => r.data);
export const adminDeleteEmailLog = (logId) => api.delete(`/email-logs/${logId}`).then((r) => r.data);
